<app-ui-spine-webgl-animation
  class="-tw-translate-x-[0.5%] tw-opacity-0 tw-transition-opacity"
  #spineAnimation
  key="zip"
  [class.tw-opacity-100]="isAnimationLoaded()"
  [animationPath]="animationPath()"
  [useBinarySkeleton]="useBinarySkeleton()"
  [skelFile]="skelFile()"
  [jsonFile]="jsonFile()"
  [atlasFile]="atlasFile()"
  [scale]="scale()"
  [mixDuration]="0.002"
  [useAdditiveBlending]="true"
  [boundsPadding]="800"
  (animationLoaded)="onAnimationLoaded()"
  (spineEvent)="onSpineEvent($event)"
  (animationComplete)="onAnimationComplete($event)"
/>

@if (showButton() && buttonText()) {
  <app-event-button
    class="tw-absolute tw-left-1/2 tw-z-10 tw-min-w-64 -tw-translate-x-1/2 tw-opacity-0 tw-transition-opacity"
    [style.top.%]="buttonTopPercent()"
    [width]="'100%'"
    [size]="'2.5'"
    [loading]="buttonLoading()"
    [class.tw-opacity-100]="isAnimationLoaded()"
    (click)="buttonClick.emit()"
  >
    {{ buttonText() }}
  </app-event-button>
}

<div
  class="loading-gradient tw-absolute tw-aspect-[0.52] tw-w-60 tw-overflow-hidden tw-rounded-xl"
  [class.tw-hidden]="isAnimationLoaded()"
></div>
